export * from '@sayyoo/services-contract';



//////////////////
// WEBPACK FOOTER
// ./~/@sayyoo/services-http-apis/lib/contract.js
// module id = GWP2
// module chunks = 256